// import Switch from 'react-ios-switch';
import Slider from "@mui/material/Slider";
import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { setQuality } from "../../Redux/DownloadSlice/downloadSlice";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import type { RootState } from "../../Redux/store";

interface ImageQualityProps {
  downloadState: RootState["downloadSlice"];
}

const ImageQuality: React.FC<ImageQualityProps> = ({ downloadState }) => {
  // Initialize state from Redux if available, otherwise default to 90
  const [size, setSize] = useState(() => {
    if (downloadState.Found && downloadState.Quality !== undefined) {
      return downloadState.Quality;
    }
    return downloadState.Quality !== undefined ? downloadState.Quality : 90;
  });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // Track the last value we dispatched to Redux to avoid sync loops
  const lastDispatchedValue = useRef(size);
  
  // Update Redux when local state changes (user interaction)
  useEffect(() => {
    if (size !== lastDispatchedValue.current) {
      lastDispatchedValue.current = size;
      dispatch(setQuality(size));
    }
  }, [size, dispatch]);
  
  // Sync with Redux when it changes externally (e.g., from GetSettings or when modal reopens)
  // This ensures the component reflects the current Redux state
  // Only sync if the Redux value is different from what we last dispatched
  useEffect(() => {
    const currentQuality = downloadState.Quality !== undefined ? downloadState.Quality : 90;
    // Only update if Redux value is different from what we last dispatched
    // This prevents loops: if user changes slider, we dispatch, Redux updates, but we don't sync back
    // If Redux changes externally (GetSettings), it will be different from lastDispatchedValue
    if (currentQuality !== lastDispatchedValue.current && currentQuality !== size) {
      lastDispatchedValue.current = currentQuality;
      setSize(currentQuality);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadState.Quality, downloadState.Found]);
  return (
    <Card className="bg_grey">
      <Card.Header>
        <Row className="p-1 productSans text_15 d-flex justify-content-start align-items-center">
          {t("DownloadImage.Quality")}
        </Row>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col
            md={10}
            className="p-1 pe-4 d-flex justify-content-center align-items-center"
          >
            <Slider
              className="slider"
              aria-label="Small"
              size="small"
              value={size}
              step={1}
              min={10}
              max={100}
              onChange={(_, value) =>
                setSize(typeof value === "number" ? value : value[0] ?? 90)
              }
            />
          </Col>
          <Col className="Aktiv text_16 p-0 d-flex justify-content-center align-items-center">
            {size + "%"}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ImageQuality;
